import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { BEConfig } from '@fantaz/shared/data-access/models';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigApiService {
  private beConfig: BEConfig;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<BEConfig> {
    return this.http
      .get<BEConfig>(`${environment.apiBaseUrl}/api/public/config`)
      .pipe(
        tap((config) => {
          this.beConfig = config;
        }),
      );
  }

  getDepositFee() {
    return this.beConfig?.depositFee || 0;
  }

  getWithdrawalFee() {
    return this.beConfig?.withdrawalFee || 0;
  }

  getBlockedCashPlayStates() {
    return this.beConfig?.blockedCashPlayStates || [];
  }

  isTSEVODisabled() {
    return this.beConfig?.TSEVO_DISABLED || false;
  }

  isEcheckEarlyDepositAllowed() {
    return Number(this.beConfig?.ECHECK_EARLY_DEPOSIT_AMOUNT || 0) > 0;
  }

  getDaysToCancelApprovedRequests() {
    return this.beConfig?.daysToCancelApprovedRequests || 7;
  }
}
